import { ChangeDetectionStrategy, ChangeDetectorRef, Input, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { DataSourceType, DataSourceTypeUtil } from 'src/app/domainObjects/dataSourceType';
import { ConfigWorkFlowStepModel } from 'src/app/views/config/config-detail/config-detail.component';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { ImportDataViewModel } from 'src/app/viewModels/importDataViewModel';
import { DataFarmType } from 'src/app/domainObjects/dataFarmType';
import { TransformListViewModel } from 'src/app/views/transformer-list/transformer-list.component';
import { ConfigService } from 'src/app/services/config/config.service';
import { UserDataService } from 'src/app/services/user-data-service';
import { MatDialog } from '@angular/material/dialog';
import { ColumnInfo, IPreviewTableDelegate, PreviewTableComponent } from 'src/app/views/preview-table/preview-table.component';
import { ColumnFilterInfo } from 'src/app/views/previewTable/filterUI/column-filter/column-filter.component';
import { PreviewDataOptions } from 'src/app/domainObjects/previewDataOptions';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { BaseComponent } from 'src/app/base/base.component';
import { GetCacheKeyRequest, GetDataFarmPreviewRequest } from 'src/app/messaging/getDataFarmPreviewRequest';
import { DataConnectorMapping } from 'src/app/domainObjects/dataConnectorMapping';
import { ColumnFilter } from 'src/app/domainObjects/columnFilter';
import { ExportOutputDataDynamicComponent } from 'src/app/views/transform/export-output-data-dynamic/export-output-data-dynamic.component';
import { SortInfo } from 'src/app/domainObjects/sortInfo';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { SharedService } from 'src/app/services/shared.service';
import { GetSummaryDataFarmPreviewRequest } from 'src/app/messaging/getSummaryDataFarmPreviewRequest';
import { MatMenuTrigger } from '@angular/material/menu';
import { SelectFilterInfo } from 'src/app/views/shared/select-filter-option/select-filter-option.component';
import { PreviewData } from 'src/app/domainObjects/previewData';
import { GetFilteredselcolvalsRequest } from 'src/app/messaging/getFilteredselcolvalsRequest';
import { Subscription } from 'rxjs';
import { CacheKeyType, PreviewType } from 'src/app/domainObjects/transformType';
import { NodeRunStatus } from 'src/app/domainObjects/nodeRunStatus';
import { CacheStatusRequest } from 'src/app/messaging/resetRefineryNodesStatusRequest';

class ViewModel {
  dataFarmName: string;
  dataFarmType: DataFarmType;
  activeFilters?: ColumnFilter[];
}

@Component({
    selector: 'app-transformer-work-flow-layout',
    templateUrl: './transformer-work-flow-layout.component.html',
    styleUrls: ['./transformer-work-flow-layout.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [],
    standalone: false
})
export class TransformerWorkFlowLayoutComponent extends BaseComponent implements OnInit, IPreviewTableDelegate {

  @Input() dataTransformConfigViewModel: DataTransformConfigViewModel;
  @Input() configWorkflowStep: ConfigWorkFlowStepModel;
  @Input() configWorkflowStepper: MatStepper;
  @Input() dataFarmType: DataFarmType;
  @Input() transforms: TransformListViewModel;

  @ViewChild('inputDataFarmPreviewTable') inputDataFarmPreviewTable: PreviewTableComponent;
  @ViewChild('outputDataFarmPreviewTable') outputDataFarmPreviewTable: PreviewTableComponent;
  @ViewChild('summaryDataFarmPreviewTableInput') summaryDataFarmPreviewTableInput: PreviewTableComponent;
  @ViewChild('summaryDataFarmPreviewTableOutput') summaryDataFarmPreviewTableOutput: PreviewTableComponent;

  @ViewChild('mapperFlowStepper') mapperFlowStepper!: MatStepper;

  previewDataViewModel = new ImportDataViewModel();
  inputcolumncount:number=0;
  outputcolumncount:number=0;
  DataSourceType = DataSourceType;
  DataSourceTypeUtil = DataSourceTypeUtil;
  private subscription!: Subscription;

  importDataViewModel: ImportDataViewModel;
  viewModel = new ViewModel();
  //previewDataViewModel = new ImportDataViewModel();
  //columnDefinitions: ColumnDefinition[];
  @ViewChild(ExportOutputDataDynamicComponent) exportComponent: ExportOutputDataDynamicComponent;

  constructor(private changeDet: ChangeDetectorRef,
              private configService: ConfigService,
              private userData: UserDataService,
              private sharedService: SharedService,
              matDialog: MatDialog, errorLogger: ErrorReportingService) { super(errorLogger, matDialog); }

  ngOnInit(): void {
    this.importDataViewModel = this.dataTransformConfigViewModel.toImportDataViewModel();
    this.viewModel.dataFarmType = this.dataFarmType;
    // Refreshes Output Preview
    this.subscription = this.sharedService.getEvent().subscribe(data => {
      this.changeDet.detectChanges();
      if(data == "display_output_preview") {
        this.outputDataFarmPreviewTable.onRefreshClicked();
      }
    });

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  ngAfterViewInit(): void {
    // //console.log('input data frame for preview-------------------------------------------------');
    // this.inputDataFarmPreviewTable.onRefreshClicked();
    // this.outputDataFarmPreviewTable.onRefreshClicked();
  }
  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async onStepCompleted(completed: boolean): Promise<void> {
    if (completed) {
      await this.delay(500);
      this.configWorkflowStepper.next();
    }
  }
  async DataPreview(): Promise<void> {
      //console.log('input data frame for preview');
      this.userData.setInputTabClicked(true);
      this.inputDataFarmPreviewTable.onRefreshClicked();
      this.outputDataFarmPreviewTable.onRefreshClicked();            
  }
  
  async refreshInputDataFarmPreviewAsync(sender: PreviewTableComponent): Promise<void> {
    sender.isGettingData.next(true);

    try {
      var configJson = this.userData.getSelectedConfigJson();
      
      const dataSourceType = configJson.dataSourceType;
      const configconnector=configJson.dataConnectorMappings[0];
      var dataconnector=configconnector.dataConnector;
      delete dataconnector['dataSourceType'];
      ////console.log('dataconnector = ', dataconnector);
      
      const dataConnectorMapping =  new DataConnectorMapping(
            configconnector.id,
            configconnector.name,
            configconnector.targetDataFarm,
            dataconnector,
            configconnector.columnMap,
            configconnector.guid,
            configconnector.masterColumnMapGuid
            // state.refineryConfigGuid,
            // state.nodeId,
            // state.nodename,
            // state.nodeType
          );
      const filters = sender.activeFilterSet?.map(f => {
          const filterInfo = new ColumnFilter();
          filterInfo.field = f.columnName;
          filterInfo.values = f.values;
          return filterInfo;
        });
        const sortInfo = this.activeSortsSet;
        const options = new PreviewDataOptions(sender.pageIndex, sender.rowsPerPage, sortInfo,filters);
      // options.NodeID = this.viewModel.activeFilters;
      var parentNodes = this.userData.getNodeParentDataLine()[0].source;
      var selectedNodes = this.userData.getSelectedNodeDetails().id;
      var refineryConfig= this.userData.getSelectedRefineryDetails() ;
      var refineryConfigGuid = refineryConfig.guid ;

       var request :GetDataFarmPreviewRequest = null;
        
      if (sender === this.inputDataFarmPreviewTable) {
        const cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.nodeInput);
        request = new GetDataFarmPreviewRequest(
          cachekeyRequest.userId,
          cachekeyRequest.orgId,
          cachekeyRequest.refineryId,
          cachekeyRequest.nodeId,
          cachekeyRequest.transformId,
          cachekeyRequest.cacheKeyType,
          options);
      }  else if (sender === this.outputDataFarmPreviewTable) {
        const cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.nodeOutput);
        request = new GetDataFarmPreviewRequest(
          cachekeyRequest.userId,
          cachekeyRequest.orgId,
          cachekeyRequest.refineryId,
          cachekeyRequest.nodeId,
          cachekeyRequest.transformId,
          cachekeyRequest.cacheKeyType,
          options);
      } 
    //var inputDataforThisNode = this.configService.getInputDataForNode(parentNodes);

        //const request=["source",parentNodes[0].source]
      const response = await this.configService.getInputDataForNode(request);
      //console.log(JSON.stringify(response));
      if(response.data.totalRows==0){
       //later implement input or output have file or not
      }
      else{
        sender.bindData(response.data, 'No input preview data');
        if (sender == this.inputDataFarmPreviewTable) {
          this.inputcolumncount=response.data.columns.length;
          if(this.selectFilterValuesInput.length > 0){
             this.refreshSummaryDataFarmPreviewAsync(this.summaryDataFarmPreviewTableInput, true);
          }
        } else {
          this.outputcolumncount=response.data.columns.length;
          if(this.selectFilterValuesOutput.length > 0){
             this.refreshSummaryDataFarmPreviewAsync(this.summaryDataFarmPreviewTableOutput, true);
          }
        }
        
      }
      
    } catch (err) {
      this.displayError('Failed to get data farm preview', 'Error', err);
    } finally {
      sender.isGettingData.next(false);
    }
  }
  
  DataFarmExport(){
    this.changeDet.detectChanges();
    this.exportComponent.initializeExportComponent();
  }
  activeSortsSet: SortInfo[]=[];
  applySorts(activeSorts: SortInfo[]){
    this.activeSortsSet = activeSorts;
  }
  clearAllSortFilter(){
    this.activeSortsSet = [];
    this.viewModel.activeFilters=[];
  }
  async onStepChange(event: StepperSelectionEvent): Promise<void> {
    //console.log('Selected index:', event.selectedIndex);
    if(event.selectedIndex==1){
      this.DataPreview();
    }else if(event.selectedIndex==2){
      const columns = this.outputDataFarmPreviewTable?.displayedColumns ?? [];
      if(columns.length > 0){
        console.log('columns.length1:', columns.length);
        this.DataFarmExport();
      }else{
        console.log('columns.length2:', columns.length);
        if(await this.getCacheStatus()){
          const busyIndicator = this.showBusyDialog('Please wait...');
          await this.refreshInputDataFarmPreviewAsync(this.outputDataFarmPreviewTable);
          this.DataFarmExport();
          busyIndicator.close();
        }else{
          this.displayWarning("No output data is available. Please run the processor first.","No Output Data");
          Promise.resolve().then(() => {
            this.mapperFlowStepper.selectedIndex = event.previouslySelectedIndex;
          });
        }
      }
    }
  }
async getCacheStatus(): Promise<boolean> {
  var cacheStatus=false;
    try {
      const request = new CacheStatusRequest(
        this.userData.getUserId(),
        this.userData.getOrgId(),
        this.userData.getRefineryId(),
        this.userData.getNodeId(),
        "",
        CacheKeyType.node);
      const response = await this.configService.getCacheStatus(request);
      if(response){
        cacheStatus=response.cacheStatus === 'Cached' ? true : false;;
      }
      
    }catch (err) {
      this.displayError('Failed to Update Node Status', 'Error', err);
    } finally {
      //sender.isGettingData.next(false);
    }
    return cacheStatus;
  }

  source: string="";
  datafarmSources?: any[]=[];

  selectValues?: any[]=[];
  selectValuesInput?: any[]=[];
  selectValuesOutput?: any[]=[];

  selectEmptyColumns?: any[]=[];
  selectEmptyColumnsInput?: any[]=[];
  selectEmptyColumnsOutput?: any[]=[];

  selectFilterValues?: any[]=[];
  selectFilterValuesInput?: any[]=[];
  selectFilterValuesOutput?: any[]=[];

  menuTrigger: MatMenuTrigger=null;
  totalSummaryRows:string="";
  totalSummaryRowsInput:string="";
  totalSummaryRowsOutput:string="";

  prevSource: string="";

  async refreshSummaryDataFarmPreviewAsync(sender: PreviewTableComponent, isNewCache: boolean = false): Promise<void> {
    const busyIndicator = this.showBusyDialog('Loading Data Preview Summary.');
    this.userData.setIsProcessrInputsummryprevwClicked(false);
    try {
      if(this.selectFilterValues.length==0){
        //this.displayWarning("No columns have been selected.","Warning");
      }else{
        const filters = sender.activeFilterSet?.map(f => {
          const filterInfo = new ColumnFilter();
          filterInfo.field = f.columnName;
          filterInfo.values = f.values;
          return filterInfo;
        });
        const options = new PreviewDataOptions(sender.pageIndex, sender.rowsPerPage);
        options.filters = filters;
        options.sortInfo= sender.activeSortsSet ?? []; 

        var request :GetSummaryDataFarmPreviewRequest = null;
        if (sender === this.summaryDataFarmPreviewTableInput) {
          this.totalSummaryRowsInput="";
          // Store the key to be used for filtering  the processor input summary preview.
          const cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.nodeInput);
          const parentFilters = (this.inputDataFarmPreviewTable.activeFilterSet ?? []).map(f => {
            const filterInfo = new ColumnFilter();
            filterInfo.field = f.columnName;
            filterInfo.values = f.values;
            return filterInfo;
          });
          request = new GetSummaryDataFarmPreviewRequest(
            cachekeyRequest.userId,
            cachekeyRequest.orgId,
            cachekeyRequest.refineryId,
            cachekeyRequest.nodeId,
            cachekeyRequest.transformId,
            cachekeyRequest.cacheKeyType,
            options,
            this.selectFilterValuesInput.join(',') ?? '');
          request.parentFilters = parentFilters;
        }else if (sender === this.summaryDataFarmPreviewTableOutput) {
          this.totalSummaryRowsOutput="";
          const cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.nodeOutput);
          const parentFilters = (this.outputDataFarmPreviewTable.activeFilterSet ?? []).map(f => {
              const filterInfo = new ColumnFilter();
              filterInfo.field = f.columnName;
              filterInfo.values = f.values;
              return filterInfo;
            });
          request = new GetSummaryDataFarmPreviewRequest(
            cachekeyRequest.userId,
            cachekeyRequest.orgId,
            cachekeyRequest.refineryId,
            cachekeyRequest.nodeId,
            cachekeyRequest.transformId,
            cachekeyRequest.cacheKeyType,
            options,
            this.selectFilterValuesOutput.join(',') ?? '');
          request.parentFilters = parentFilters;
        }
        if(request != null) {
            request.isNewCache=isNewCache;
            const response = await this.configService.getSummaryDataFarm(request);
            if(response.data.totalRows==0){
              //this.totalSummaryRows="";
            //later implement input or output have file or not
            }
            else{
              const totalRows = Number(response.data.totalSummaryFarmRows).toLocaleString();
              if (sender === this.summaryDataFarmPreviewTableInput) {
                this.totalSummaryRowsInput="Total Row Count: "+totalRows;
              } else if (sender === this.summaryDataFarmPreviewTableOutput) {
                this.totalSummaryRowsOutput="Total Row Count: "+totalRows;
              }
              // remove 0 should be remove in python later
              const countColumns = response.data.columns
                .filter(col => col.columnName.includes('count'));

              var rowdata=Object.values(response.data.rows);
              rowdata.forEach(row => {
                countColumns.forEach(col => {
                  const colIndex = col.index.toString();
                  if (row[colIndex] === 0) {
                    row[colIndex] = ''; // Replace 0 with blank
                  }
                });
              });

              sender.bindData(response.data, 'No Summary preview data');
        }
       }
      }
    } catch (err) {
      this.displayError('Failed to get data farm preview', 'Error', err);
    } finally {
      sender.isGettingData.next(false);
      busyIndicator.close();
    }
  }
  
  async onApplySelect(info: SelectFilterInfo): Promise<void> {
    this.source=info.source;
    this.selectFilterValues=info.values.filter(cl=>cl!=null).map(col=>col);
    this.menuTrigger.closeMenu();
    this.prevSource=this.source;
    if(info.source == "Input"){
      this.selectFilterValuesInput=[...this.selectFilterValues];
      await this.clearAllSortFilterCache(this.summaryDataFarmPreviewTableInput,true);
    }else if(info.source == "Output") {
      this.selectFilterValuesOutput=[...this.selectFilterValues];
      await this.clearAllSortFilterCache(this.summaryDataFarmPreviewTableOutput,true);
    }
  }

  async onClearSelect(colName: string): Promise<void> {
    //this.source=this.prevSource;
    //await this.bindSummary(this.source);
    this.menuTrigger.closeMenu();
  }

  onCloseSelect(): void {
    this.menuTrigger.closeMenu();
  }
  async showSelectFilter(menuTrigger: MatMenuTrigger,source:string="Input"): Promise<void> {
    this.source=source;
    this.menuTrigger=menuTrigger;
    //this.menuTrigger.closeMenu();
    await this.bindSummary(this.source);
    this.changeDet.detectChanges();
    this.menuTrigger.openMenu();
  }
  async onChangeSource(sourcetype:string){
    await this.bindSummary(sourcetype);
  }
  async bindSummary(sourcetype:string): Promise<void> {
    if(sourcetype=="Input"){
      if(this.selectValuesInput.length==0){
        await this.bindSelectValues(sourcetype);
      }
      this.selectValues =[...new Set(this.selectValuesInput)];
      this.selectEmptyColumns =[...new Set(this.selectEmptyColumnsInput)];
      this.selectFilterValues=[...new Set(this.selectFilterValuesInput)];
    }else if(sourcetype=="Output"){
      if(this.selectValuesOutput.length==0){
        await this.bindSelectValues(sourcetype);
      }
      this.selectValues =[...new Set(this.selectValuesOutput)];
      this.selectEmptyColumns =[...new Set(this.selectEmptyColumnsOutput)];
      this.selectFilterValues=[...new Set(this.selectFilterValuesOutput)];
    }
    this.changeDet.detectChanges();
  }
  async bindSelectValues(sourcetype:string): Promise<void> {
    try {
      var request :GetSummaryDataFarmPreviewRequest = null;
      if(sourcetype=="Input"){
        this.selectValuesInput = [...this.inputDataFarmPreviewTable.displayedColumnInfos.map(map => map.name).filter(mp=>mp!='row')];
        const cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.nodeInput);
        request = new GetSummaryDataFarmPreviewRequest(
          cachekeyRequest.userId,
          cachekeyRequest.orgId,
          cachekeyRequest.refineryId,
          cachekeyRequest.nodeId,
          cachekeyRequest.transformId,
          cachekeyRequest.cacheKeyType,
          null,
          this.selectFilterValues.join(',') ?? '',
          null);
        const response = await this.configService.getSummaryEmptyColslist(request);
        this.selectEmptyColumnsInput=response.blanks_cols_list;
      }else if(sourcetype=="Output"){
        if(this.outputDataFarmPreviewTable.displayedColumnInfos){
          this.selectValuesOutput = [...this.outputDataFarmPreviewTable.displayedColumnInfos.map(map => map.name).filter(mp=>mp!='row')];
          const cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.nodeOutput);
          request = new GetSummaryDataFarmPreviewRequest(
            cachekeyRequest.userId,
            cachekeyRequest.orgId,
            cachekeyRequest.refineryId,
            cachekeyRequest.nodeId,
            cachekeyRequest.transformId,
            cachekeyRequest.cacheKeyType,
            null,
            this.selectFilterValues.join(',') ?? '',
            null);
          const response = await this.configService.getSummaryEmptyColslist(request);
          this.selectEmptyColumnsOutput=response.blanks_cols_list;
        }else{
          this.displayWarning("There is no Output Farm, please run the Processor/Ingest Node/Transformer.","Warning");
          this.selectValuesOutput = [...new Set([])];
        }
      }
    }catch (err) {
      this.displayError('Failed to get data Empty column list', 'Error', err);
    } finally {
      //sender.isGettingData.next(false);
    }
  }
  
  async clearFarmPreviewTable(){
      const pvb: PreviewData = {
        columns: [],
        rows: {},
        totalRows: 0,
        totalSummaryFarmRows: 0,
        cacheFileCreationDtTime: ''
      };
  
      //this.summaryDataFarmPreviewTable.bindData(pvb, 'No Summary preview data');
      //this.totalSummaryRows="";
  }
  async refreshSummaryPreviewTable(){
    if(this.source=="Output"){
      this.selectValues = [...new Set([])];
      await this.clearFarmPreviewTable();
      await this.bindSelectValues(this.source);
      this.selectFilterValues = this.selectFilterValues.filter(
        sf => !this.selectEmptyColumns.includes(sf)
      );
      await this.summaryDataFarmPreviewTableOutput.onRefreshClicked();
    }
  }
  // onShowFilter1(event: { trigger: MatMenuTrigger, columnName: string }){
  //   var parentNodes = this.userData.getNodeParentDataLine()[0].source;
  //   var selectedNodes = this.userData.getSelectedNodeDetails().id;
  //   var request :GetFilteredselcolvalsRequest = null;
  //   if (this.source === "Input") {
  //     request = new GetFilteredselcolvalsRequest(
  //       this.userData.getUserId(),
  //       this.userData.getOrgId(),
  //       this.userData.getRefineryId(),
  //       parentNodes,//this.userData.getNodeId(),
  //       this.userData.getTransformId(),
  //       CacheKeyType.ingestInput,
  //       event.columnName);
  //   }else if (this.source === "Output") {
  //     request = new GetFilteredselcolvalsRequest(
  //       this.userData.getUserId(),
  //       this.userData.getOrgId(),
  //       this.userData.getRefineryId(),
  //       selectedNodes,//this.userData.getNodeId(),
  //       this.userData.getTransformId(),
  //       CacheKeyType.ingestInput,
  //       event.columnName);
  //   }
  //   this.summaryDataFarmPreviewTable.fetchselectedcolsvalsfrmAPI(request);
  // }
  //Preview Table Delegate
  async onRefreshClicked(sender: PreviewTableComponent): Promise<void> {
    await this.refreshPreviewTable(sender);
  }
  async refreshPreviewTable(sender: PreviewTableComponent): Promise<void> {
    // Download the data for the previewTable
    if (sender === this.inputDataFarmPreviewTable) {
      await this.refreshInputDataFarmPreviewAsync(sender);
    }else if (sender === this.outputDataFarmPreviewTable) {
      await this.refreshInputDataFarmPreviewAsync(sender);
    }else if (sender === this.summaryDataFarmPreviewTableInput){
      await this.refreshSummaryDataFarmPreviewAsync(sender);
    }else if (sender === this.summaryDataFarmPreviewTableOutput){
      await this.refreshSummaryDataFarmPreviewAsync(sender);
    }
  }
  async onPageChanged(sender: PreviewTableComponent, totalRows: number, pageSize: number, pageIndex: number): Promise<number> {
    await this.refreshPreviewTable(sender);
    return totalRows;
  }

async onShowFilter(sender: PreviewTableComponent, columnName: string): Promise<void> {    
    // if(this.viewModel.activeFilters == undefined || this.viewModel.activeFilters.length == 0) {
    if(sender.activeFilterSet == undefined || sender.activeFilterSet.length == 0) {
        const busyIndicator = this.showBusyDialog('Please wait...');
        var cachekeyRequest:GetCacheKeyRequest=null;
        if(sender === this.inputDataFarmPreviewTable) {
          cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.nodeInput);
        }else if (sender === this.outputDataFarmPreviewTable) {
          cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.nodeOutput);
        }else if (sender === this.summaryDataFarmPreviewTableInput) {
          cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.nodeInput);
        }else if (sender === this.summaryDataFarmPreviewTableOutput) {
          cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.nodeOutput);
        }
      
        try{
          var request = new GetFilteredselcolvalsRequest(
            cachekeyRequest.userId,
            cachekeyRequest.orgId,
            cachekeyRequest.refineryId,
            cachekeyRequest.nodeId,
            cachekeyRequest.transformId,
            cachekeyRequest.cacheKeyType,
            columnName);
          await sender.fetchselectedcolsvalsfrmAPI(request);
        } catch(ex) {
          console.error('Error fetching data:', ex);
          this.displayError('Failed to fetch filter values. Please try again later.',"Failed to fetch");
        } finally {
          busyIndicator.close();
        }
      } else {
        sender.applyStackFilters(columnName);
      }
    
  }

  async onApplyFilter(sender: PreviewTableComponent, filterSet: ColumnFilterInfo[], info: ColumnFilterInfo): Promise<void> {
    const busyIndicator = this.showBusyDialog('Please wait...');
    
    if (!this.viewModel.activeFilters) {
      this.viewModel.activeFilters = [];
    }

    // remove existing filter by columnName
    this.viewModel.activeFilters = this.viewModel.activeFilters.filter(f => f.field !== info.columnName);

    // add new filter to active set
    const columnFilter = new ColumnFilter();
    columnFilter.field = info.columnName;
    columnFilter.values = info.values;

    this.viewModel.activeFilters.push(columnFilter);
    await this.refreshPreviewTable(sender);
    busyIndicator.close();
  }
  async onClearFilter(sender: PreviewTableComponent, filterSet: ColumnFilterInfo[], columnName: string): Promise<void> {
    const busyIndicator = this.showBusyDialog('Please wait...');
    // remove existing filter by columnName
    if(this.viewModel.activeFilters){
      this.viewModel.activeFilters = this.viewModel.activeFilters.filter(f => f.field !== columnName);
    }
    await this.refreshPreviewTable(sender);
    busyIndicator.close();
  }

  async onApplySort(sender: PreviewTableComponent, sortData: SortInfo[]): Promise<void> {
    this.activeSortsSet = sortData;
  }

  async onClearAllSortFilter(sender: PreviewTableComponent): Promise<void> {
    this.activeSortsSet = [];
    this.viewModel.activeFilters=[];
    this.clearAllSortFilterCache(sender,false);
  }
  async clearAllSortFilterCache(sender: PreviewTableComponent, isNewCache: boolean = false): Promise<void> {
    sender.activeFilterSet=[];
    sender.activeSortsSet=[];
    this.refreshSummaryDataFarmPreviewAsync(sender,isNewCache);
  }
  getClassForRow(sender: PreviewTableComponent, row: any, colInfo: ColumnInfo, columns: ColumnInfo[]): string {
    return null;
  }
  //Preview Table Delegate End

  async GetCacheKeyRequest(previewType:PreviewType): Promise<GetCacheKeyRequest> {
    let transformId = (this.userData.getTransformId() == undefined) ? null : this.userData.getTransformId();
    var request = new GetCacheKeyRequest(
        this.userData.getUserId(),
        this.userData.getOrgId(),
        this.userData.getRefineryId(),
        this.userData.getNodeId(),
        transformId,
        CacheKeyType.node);

    if(previewType === PreviewType.nodeInput) {
      const parentNode = this.userData.getNodeParentDataLine()[0].source;
      request.nodeId=parentNode;
      request.cacheKeyType=CacheKeyType.node;
    }else if (previewType === PreviewType.nodeOutput) {
      request.cacheKeyType=CacheKeyType.node;
    }

    return request;
  }
}
